<txtb-modal [title]="action.meta.title">
  <div
    main
    class="document-wrapper"
    #wrapper
    [class.paginator-hidden]="!pagination"
    [style.width]="'auto'"
    [style.height]="'auto'"
  >
    <article class="document-image">
      <txtb-image-wrapper
        [fixRender]="true"
        [proportionalRender]="false"
        [fluid]="true"
        [currentDeviceOS]="currentDeviceOS$ | async"
        *ngFor="
          let resourceId of action.meta.resourceIds
            | paginate
              : {
                  itemsPerPage: 1,
                  currentPage: activeElementIndex,
                  totalItems: action.meta.resourceIds.length
                }
        "
        [attr.sub]="imageSrc$(resourceId, activeElementIndex) | async"
        [attr.orientation]='windowOrientation$ | async'
        alt="fragment podręcznika"
        [src]="imageSrc[activeElementIndex]"
        [imgSrc]="imageSrc[activeElementIndex]"
      ></txtb-image-wrapper>
    </article>
  </div>
  <section class="pagination-wrapper" footer *ngIf="pagination">
    <txtb-documents-paginator
      (pageChange)="changeElement($event)"
      class="paginator"
    ></txtb-documents-paginator>
  </section>
</txtb-modal>
